export const PURCHASE_PRICE_WITHOUT_VAT = 'цена покупки (без НДС)';
export const WITHOUT_VAT = '(без НДС)';
